import React from "react"
import classnames from "@utils/classnames"
import Section from "@components/section"
import Frame from "@components/frame"
import styles from "./footer.module.scss"
import config from "@config"

import logosImg from "@images/logos-last.png"

const Footer = React.memo(props => {
  return (
    <>
      <Section>
        <div className={styles.buttons}>
          <Frame type="button" href={config.urls.volunteer}>
            成为志愿者
          </Frame>
          <Frame type="button" href={config.urls.chat}>
            参与讨论
          </Frame>
        </div>
      </Section>
      <Section>
        <div className={styles.logosContainer}>
          <img
            src={logosImg}
            alt="logos"
            className={classnames("fluidImg", styles.logos)}
          />
        </div>
      </Section>
    </>
  )
})

Footer.displayName = "Footer"
export default Footer
